import { Formik, Form, FieldArray } from "formik";
import * as Yup from "yup";

const isNomineeBelow18 = (nomineeDateOfBirth) => {
  // Implement your logic to check if the nominee is below 18 years old
  const dob = new Date(nomineeDateOfBirth);
  const today = new Date();
  const age = today.getFullYear() - dob.getFullYear();

  // console.log("age", age);
  return age;
};

const isGuardianRequired = (relationShip) => {
  // Implement your logic to check if guardian is required based on the relationship
  const requiredRelationships = [
    "Son",
    "Daughter",
    "Grand son",
    "Grand daughter",
    "Others",
    "Brother",
    "Sister",
  ];
  return (
    relationShip.length > 0 &&
    requiredRelationships.includes(relationShip[0].value)
  );
};

export const schema = Yup.object().shape({
  nominees: Yup.array().of(
    Yup.object().shape({
      nomineeFullName: Yup.string()
        .required("Nominee Name is Required")
        .max(50)
        .matches(/^[a-zA-Z ]*$/, "Enter Valid Name")
        .transform((value: any) => value && value.toUpperCase()),

      nomineeEmail: Yup.string()
        .required("Email is Required")
        .max(50)
        .matches(
          /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
          "Enter Valid Email"
        ),
      // nomineeDateofBirth: Yup.string()
      //   .required("Nominee Date of Birth is a required")
      //   .test((value: any) => {
      //     if (!value) return true; // Let the required validation handle empty values

      //     const currentDate: any = new Date();
      //     console.log("Current Date:", currentDate);

      //     const dob: any = new Date(value);
      //     console.log("DOB:", dob);

      //     const ageInYears =
      //       (currentDate - dob) / (365.25 * 24 * 60 * 60 * 1000); // Age in years
      //     console.log("Age in Years:", ageInYears);

      //     return ageInYears <= 100;
      //   }),

      nomineeDateofBirth: Yup.string()
        .required("Nominee Date of Birth is required")
        .test({
          name: "valid-age",
          message: "Age must be between 1 and 100",
          test: function (value) {
            if (!value) return true; // Let the required validation handle empty values

            const currentDate: any = new Date();
            const dob: any = new Date(value);

            if (isNaN(dob)) {
              return this.createError({
                message: "Enter Valid Date", // Custom error message for invalid date
                path: "nomineeDateofBirth", // Field name
              });
            }

            const ageInYears =
              (currentDate - dob) / (365.25 * 24 * 60 * 60 * 1000); // Age in years

            return ageInYears >= 0 && ageInYears <= 100;
          },
        }),

      nomineeMobileNumber: Yup.string()
        .required("Mobile Number is Required")
        .max(10)

        .matches(/^[0-9]{10}$/, "Enter Valid Number"),

      percentageofShare: Yup.string()
        .required("Percentage is Required")
        .max(3)
        .matches(/^[0-9]+%*$/, "Enter Valid Percentage"),
      nomineeAddress: Yup.string().required("Address is Required"),
      nomineeAddressPinCode: Yup.string()
        .required("Pincode is Required")
        .max(6),
      nomineeAddressCity: Yup.string().required("City is Required").max(50),
      nomineeAddressState: Yup.object().required("State is Required"),

      relationShip: Yup.object().required("Please select an option"),
      relationshipIfOthers: Yup.string().when(
        "relationShip",
        (relationShip: any, schema: any) => {
          // console.log("relationShip", relationShip);
          if (
            relationShip.length &&
            relationShip[0] &&
            relationShip[0].value === "Others"
          ) {
            return schema
              .required("Relationship is Required")
              .matches(/^[a-zA-Z ]*$/, "Enter Valid Relation")
              .max(50)
              .transform((value: any) => value && value.toUpperCase());
          }

          return schema;
        }
      ),

      gaurdianFullName: Yup.string()
        .matches(/^[a-zA-Z ]*$/, "Enter Valid Name")
        .max(50)
        .when(
          ["relationShip", "nomineeDateofBirth"],
          (relationShip: any, schema: any) => {
            //  console.log("relationShip", relationShip);
            if (
              isNomineeBelow18(relationShip[1]) < 18 &&
              isGuardianRequired(relationShip)
            ) {
              return schema
                .required("Please Enter Gaurdian Name")
                .matches(/^[a-zA-Z ]*$/, "Enter Valid Relation");
              // .transform((value: any) => value && value.toUpperCase());
            }
          }
        ),
      gaurdianDateofBirth: Yup.string().when(
        ["relationShip", "nomineeDateofBirth"],
        (relationShip: any, schema: any) => {
          // console.log("relationShip", relationShip);
          if (
            isNomineeBelow18(relationShip[1]) < 18 &&
            isGuardianRequired(relationShip)
          ) {
            return schema.required("Gaurdian Date of Birth is a required")
            .test({
              name: "valid-age",
              message: "Age must be between 1 and 100",
              test: function (value:any) {
                if (!value) return true; // Let the required validation handle empty values
    
                const currentDate: any = new Date();
                const dob: any = new Date(value);
    
                if (isNaN(dob)) {
                  return this.createError({
                    message: "Enter Valid Date", // Custom error message for invalid date
                    path: "gaurdianDateofBirth", // Field name
                  });
                }
    
                const ageInYears =
                  (currentDate - dob) / (365.25 * 24 * 60 * 60 * 1000); // Age in years
    
                return ageInYears >= 0 && ageInYears <= 100;
              }
            })
          }
        }
      ),

      gaurdianEmail: Yup.string()
        .matches(
          /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
          "Enter Valid Email"
        )
        .max(50)
        .when(
          ["relationShip", "nomineeDateofBirth"],
          (relationShip: any, schema: any) => {
            // console.log("relationShip", relationShip);
            if (
              isNomineeBelow18(relationShip[1]) < 18 &&
              isGuardianRequired(relationShip)
            ) {
              return schema.required("Gaurdian Email is a required");
            }
          }
        ),

      gaurdianMobileNumber: Yup.string()
        .matches(/^[0-9]{10}$/, "Enter Valid Number")
        .when(
          ["relationShip", "nomineeDateofBirth"],
          (relationShip: any, schema: any) => {
            // console.log("relationShip", relationShip);
            if (
              isNomineeBelow18(relationShip[1]) < 18 &&
              isGuardianRequired(relationShip)
            ) {
              return schema.required("Gaurdian PhoneNumber is a required");
            }
          }
        ),

      gaurdianRelationWithNominee: Yup.object().when(
        ["relationShip", "nomineeDateofBirth"],
        (relationShip: any, schema: any) => {
          // console.log("relationShip", relationShip);
          if (
            isNomineeBelow18(relationShip[1]) < 18 &&
            isGuardianRequired(relationShip)
          ) {
            return schema.required(
              "Gaurdian Relation With Nominee is a required"
            );
          }
        }
      ),
      gaurdianAddress: Yup.string().when(
        ["relationShip", "nomineeDateofBirth"],
        (relationShip: any, schema: any) => {
          // console.log("relationShip", relationShip);
          if (
            isNomineeBelow18(relationShip[1]) < 18 &&
            isGuardianRequired(relationShip)
          ) {
            return schema.required("Gaurdian Address is required").max(250);
          }
        }
      ),
      gaurdianAddressPinCode: Yup.string().when(
        ["relationShip", "nomineeDateofBirth"],
        (relationShip: any, schema: any) => {
          // console.log("relationShip", relationShip);
          if (
            isNomineeBelow18(relationShip[1]) < 18 &&
            isGuardianRequired(relationShip)
          ) {
            return schema.required("Gaurdian PinCode is required").max(6);
          }
        }
      ),
      gaurdianAddressCity: Yup.string().when(
        ["relationShip", "nomineeDateofBirth"],
        (relationShip: any, schema: any) => {
          // console.log("relationShip", relationShip);
          if (
            isNomineeBelow18(relationShip[1]) < 18 &&
            isGuardianRequired(relationShip)
          ) {
            return schema.required("Gaurdian City is required").max(50);
          }
        }
      ),
      gaurdianAddressState: Yup.object().when(
        ["relationShip", "nomineeDateofBirth"],
        (relationShip: any, schema: any) => {
          // console.log("relationShip", relationShip);
          if (
            isNomineeBelow18(relationShip[1]) < 18 &&
            isGuardianRequired(relationShip)
          ) {
            return schema.required("Gaurdian State is required");
          }
        }
      ),

      nomineeIDProof: Yup.string().notRequired(),
      nomineeIDProofNo: Yup.string()
        .notRequired()
        .when("nomineeIDProof", (nomineeIDProof: any, schema: any) => {
          if (nomineeIDProof[0] === "Aadhaar Card")
            return schema
              .notRequired()
              .length(12, "Enter Valid Aadhaar Number")
              .matches(/^([0-9])/, "Enter Valid Aadhaar Number")
              .transform((value: any) => value && value.toUpperCase());

          if (nomineeIDProof[0] === "Pan Card")
            return schema
              .notRequired()
              .length(10, "Enter Valid Pan Number")
              .matches(
                /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/,
                "Enter Valid Pan Number"
              )
              .transform((value: any) => value && value.toUpperCase());

          return schema;
        }),
      // nomineePanCardNo: Yup.string().when("nomineeIDProof", {
      //   is: "panCardNo",
      //   then(schema) {
      //     return schema.required(" Nominee ID Number is a required");
      //   },
      // }),
    })
  ),
});
function dayjs(arg0: string): any {
  throw new Error("Function not implemented.");
}
